import type { ReactNode } from 'react'
import type { GestureResponderEvent } from 'react-native'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Typography } from '@/src/elements/text/Typography'
import { getTotalSharesCount } from '@/src/features/share/utils/getTotalSharesCount'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import type { TPublicationApi } from '../../api/types/getPublication.types'

export type TPublicationShareCommentButtonsProps = {
  publication: Partial<Pick<TPublicationApi<'sharesCount'>, 'commentsCount' | 'sharesCount'>>
  onSharePress?: (e?: GestureResponderEvent | React.MouseEvent) => void
  onCommentPress?: (e?: GestureResponderEvent | React.MouseEvent) => void
  colors: 'default' | 'primary' | 'success'
}

export const PublicationShareCommentButtons = ({
  publication,
  onCommentPress,
  onSharePress,
  colors,
}: TPublicationShareCommentButtonsProps): ReactNode => {
  if (!onSharePress || !onCommentPress) return null

  const defaultTextColorClassName = colors === 'default' ? 'text-default-icon-contrast-lower' : undefined

  return (
    <View className="flex-row gap-3">
      <View className="flex-row items-center gap-0">
        <Button
          size="sm"
          colors={colors}
          contrast="low"
          variant="light"
          startIcon={ICON.SHARE}
          onPress={onSharePress}
          isIconOnly
          testID={TEST_ID.PUBLICATION_CARD.SHARE_BUTTON}
          textClassName={defaultTextColorClassName}
        />
        {'sharesCount' in publication && (
          <Typography bold colors={colors} contrast="low" className={defaultTextColorClassName} size="sm">
            {getTotalSharesCount(publication.sharesCount)}
          </Typography>
        )}
      </View>
      <View className="flex-row items-center gap-0">
        <Button
          size="sm"
          colors={colors}
          contrast="low"
          variant="light"
          startIcon={ICON.MESSAGE_CHAT}
          onPress={onCommentPress}
          isIconOnly
          testID={TEST_ID.PUBLICATION_CARD.COMMENT_BUTTON}
          textClassName={defaultTextColorClassName}
        />
        {typeof publication.commentsCount === 'number' && (
          <Typography bold colors={colors} contrast="low" className={defaultTextColorClassName} size="sm">
            {publication.commentsCount}
          </Typography>
        )}
      </View>
    </View>
  )
}
